import React, { useState } from 'react';
import { useMediaAttachment } from '../../../hooks/useMediaAttachment';
import { MediaOverlay } from './MediaOverlay';
import MediaModal from "../../../../../Components/MediaModal";
import { WhatsappMessage } from '../../../types/whatsapp';

interface ImageAttachmentProps {
    mediaId: string;
    caption?: string;
    messages?: WhatsappMessage[];
    currentMessageId?: string;
    getMediaUrl?: (mediaId: string, type: string) => Promise<string>;
}

export const ImageAttachment = ({ mediaId, caption, messages, currentMessageId, getMediaUrl }: ImageAttachmentProps) => {
    const { url, status, downloadMedia } = useMediaAttachment(mediaId);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const canOpen = status === 'SUCCESS' && !!url;
    const toggleModal = () => setIsModalOpen(v => !v);

    return (
        <div className="d-flex flex-column gap-1">
            <div
                className="position-relative bg-dark rounded"
                style={{ minWidth: '200px', minHeight: '150px', overflow: 'hidden', cursor: canOpen ? 'pointer' : 'default' }}
                onClick={() => { if (canOpen) setIsModalOpen(true); }}
            >
                <MediaOverlay status={status} typeLabel="Imagen" icon={<i className="ri-image-line"></i>} onClick={downloadMedia} />
                {url && status === 'SUCCESS' && (
                    <img src={url} alt={caption || 'Imagen adjunta'} className="w-100 h-auto" style={{ maxHeight: '300px', objectFit: 'cover' }} loading="lazy" />
                )}
            </div>
            {caption && <div className="text-break" style={{ whiteSpace: 'pre-wrap' }}>{caption}</div>}

            {/* Usa el componente MediaModal para la imagen ampliada */}
            {messages && currentMessageId && getMediaUrl ? (
                <MediaModal
                    isOpen={isModalOpen}
                    toggle={toggleModal}
                    messages={messages}
                    initialMessageId={currentMessageId}
                    getMediaUrl={getMediaUrl}
                />
            ) : (
                <MediaModal
                    isOpen={isModalOpen}
                    toggle={toggleModal}
                    messages={[]}
                    initialMessageId={null}
                    getMediaUrl={async (id) => url || ''}
                />
            )}
        </div>
    );
};
